<template>
  <BaseOrdersLoadingIndicator
    :progressPercent="ordersProgress"
    v-if="!completed" />
</template>

<script>
  import BaseOrdersLoadingIndicator from '@/components/BaseOrdersLoadingIndicator'

  export default {
    name: 'RemainingOrdersLoadingIndicator',
    components: {
      BaseOrdersLoadingIndicator
    },
    data: function () {
      return {
        completed: true,
        interval: false,
        ordersImported: 0,
        ordersTotal: 0
      }
    },
    computed: {
      ordersProgress: function () {
        return (this.ordersTotal === 0 ? 0 : Math.min(100, this.ordersImported / this.ordersTotal * 100)).toFixed(0)
      }
    },
    mounted: function () {
      this.init()
    },
    methods: {
      init () {
        if (this.$router.currentRoute.name.includes('Product')) {
          this.importProgress()
        }
      },
      importProgress () {
        if (this.$shop && this.$shop.complete_import) {
          return
        }

        this.loadUser().then(() => {
          if (!this.$shop.complete_import) {
            this.completed = false
            if (!this.interval) {
              this.interval = setInterval(() => { this.importProgress() }, 5000)
            }

            this.ordersTotal = this.$shop.data.initial_import.orders_all
            this.ordersImported = this.$shop.orders_all_import
          } else {
            this.completed = true
            if (this.interval) {
              clearInterval(this.interval)
            }
          }
        })
      }
    },
    watch: {
      '$route.name': function (name) {
        this.init()
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/js/components/RemainingOrdersLoadingIndicator.vue